module.exports = __webpack_public_path__ + "img/2.ab891c54.png";